import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, getFirestore, addDoc, query, where, deleteDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCLuWtlmtfkioCgpyr-5kGS9_LUBBavCK4",
  authDomain: "pdcheck-d2c58.firebaseapp.com",
  projectId: "pdcheck-d2c58",
  storageBucket: "pdcheck-d2c58.appspot.com",
  messagingSenderId: "83462427832",
  appId: "1:83462427832:web:b9b7239404b9816e7c104d",
  measurementId: "G-NVJ521KCTS"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup, signOut, onAuthStateChanged };

export async function getChecks(userId) {
  const q = query(collection(db, "checks"), where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  return querySnapshot
}

export function saveCheck(check, userId) {
  addDoc(collection(db, "checks"), { ...check, userId })
  .then(() => {
    console.log("Check saved")
  })
  .catch(e => {
    console.error("Error saving check, the check was not saved. ", e)
  })
}

export async function deleteCheck(checkId, userId) {
  const q = query(
    collection(db, "checks"),
    where("id", "==", checkId),
    where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    deleteDoc(doc.ref);
  });
}
